<template>
  <div class="row mt-2">
    <div class="col-md-12">
      <label>
        <input type="checkbox" name="isNowTimeValue" v-model="control.isNowTimeValue">
        <span
          v-back-to-default="[
            $parent.inheritedControlInfo,
            control,
            'isNowTimeValue',
            $parent.backToDefault
          ]"
        />
        <span>Auto-input Current Time?</span>
      </label>
    </div>

    <div class="col-md-12">
      <div class="form-group">
        <label
          v-back-to-default="[
            $parent.inheritedControlInfo,
            control,
            'timeFormat',
            $parent.backToDefault
          ]"
        >
          Time Format
        </label>
        <select2-control :options="timeFormatOptions" v-model="control.timeFormat"></select2-control>
      </div>
    </div>
  </div>
</template>

<script>
  import Select2Control from "@/components/DataGrid/FormBuilder/third_party_controls/Select2Control";
  import {CONTROL_CONSTANTS} from "@/components/DataGrid/FormBuilder/config/constants";

  export default {
    name: "TimePickerConfigComponent",
    components: {Select2Control},
    props: {
      control: {
        type: Object
      },
    },
    data: () => ({
      timeFormatOptions: [],
    }),
    created() {
      this.timeFormatOptions = _.map(CONTROL_CONSTANTS.TimeFormat, (value, key) => {
        return key;
      });
    },
  }
</script>

<style scoped>

</style>
